import React from 'react'
import styled from 'styled-components'
import Spin from 'frontend_component/dist/components/atoms/Spin'
import Icon from 'frontend_component/dist/components/atoms/Icon'

export default props => {
  const { ui, onSelectFile, fileName } = props

  return (
    <div>
      <InputFile>
        <Icon
          className="icon-spm-upload"
          positionType="left"
          padding="0 4px 0 0"
        />
        {i18n.t('page.employee.l_00033')}
        <input type="file" accept=".csv" onChange={onSelectFile} />
      </InputFile>
      <FileNameWrapper
        isShowFileName={ui.startUpload}
        uploadError={ui.uploadError}
      >
        {ui.mutateLoading && <Spin size="small" />}
        {!ui.mutateLoading && (
          <Icon className="icon-spm-clip" padding="0 4px 0 0" />
        )}
        {fileName}
      </FileNameWrapper>
    </div>
  )
}

const InputFile = styled.label`
  background: #fff;
  font-weight: bold;
  border: 1px solid #00a273;
  color: #00a273;
  padding: 10px 16px;
  border-radius: 3px;
  display: inline-block;
  cursor: pointer;
  & input {
    display: none;
  }
  &:hover {
    background: #fff;
    color: #60ce52;
    border: 1px solid #60ce52;
  }
`

const FileNameWrapper = styled.p`
  margin-top: 8px;
  padding: 10px 2px;
  display: ${props => (props.isShowFileName ? 'block' : 'none')};
  color: ${props => (props.uploadError ? '#e95175' : '#333')};
`
